import { render, staticRenderFns } from "./HotelsListItem.vue?vue&type=template&id=fb73e21c"
import script from "./HotelsListItem.vue?vue&type=script&lang=js"
export * from "./HotelsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelsCarousel: require('/home/forge/farescraper.com/components/HotelsCarousel.vue').default,IconsHotel: require('/home/forge/farescraper.com/components/IconsHotel.vue').default,DropdownPartnerItem: require('/home/forge/farescraper.com/components/DropdownPartnerItem.vue').default})
